__turbopack_context__.v({
  "disclaimer": "InsightQA-module__nZ7rNq__disclaimer",
  "header": "InsightQA-module__nZ7rNq__header",
  "panel": "InsightQA-module__nZ7rNq__panel",
  "thinking": "InsightQA-module__nZ7rNq__thinking",
  "thinkingLabel": "InsightQA-module__nZ7rNq__thinkingLabel",
});
